import { render } from "./Dropdown.vue?vue&type=template&id=ef52e6b4&scoped=true"
import script from "./Dropdown.vue?vue&type=script&lang=js"
export * from "./Dropdown.vue?vue&type=script&lang=js"

import "./Dropdown.vue?vue&type=style&index=0&id=ef52e6b4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef52e6b4"]])

export default __exports__